import { render } from "./chatMenu.vue?vue&type=template&id=6d476592"
import script from "./chatMenu.vue?vue&type=script&lang=js"
export * from "./chatMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__